import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { MaterialModule } from '../../material.module';
import { MomentModule } from 'ngx-moment';
import { RouterModule } from '@angular/router';
import { SummaryModule } from '../summary/summary.module';
import { UnsubscribeComponent } from './unsubscribe.component';

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        GeneralModule,
        ReactiveFormsModule,
        MaterialModule,
        MomentModule,
        RouterModule,
        SummaryModule
    ],
    declarations: [
        UnsubscribeComponent
    ],
    exports: [
        UnsubscribeComponent
    ]
})
export class AccountModule {
}